import api from '@/shared/api/api-client';

import { sessionDetailSchema } from '../domain/session-detail.model';
import type { SessionDetailGateway } from './session-detail.gateway';

const SESSIONS_ENDPOINT = '/enrichment-sessions';
const PIPELINES_ENDPOINT = '/enrichment-pipelines';

/**
 * Real implementation over the shared api client; the single place that knows
 * this feature's endpoints (kept 1:1 with the original component). The read
 * validates at the boundary with Zod; the pipeline actions are plain POSTs.
 */
export const httpSessionDetailGateway: SessionDetailGateway = {
  getSession: async (id) =>
    sessionDetailSchema.parse(await api.get<unknown>(`${SESSIONS_ENDPOINT}/${id}`)),

  pause: async (id) => {
    await api.post(`${PIPELINES_ENDPOINT}/${id}/pause`);
  },
  resume: async (id) => {
    await api.post(`${PIPELINES_ENDPOINT}/${id}/resume`);
  },
  retry: async (id) => {
    await api.post(`${PIPELINES_ENDPOINT}/${id}/retry`);
  },
  cancel: async (id) => {
    await api.post(`${PIPELINES_ENDPOINT}/${id}/cancel`);
  },
  reset: async (id) => {
    await api.post(`${PIPELINES_ENDPOINT}/${id}/reset`);
  },
  retryTargets: async (id, targetIds) => {
    await api.post(`${PIPELINES_ENDPOINT}/${id}/retry-targets`, { target_ids: targetIds });
  },
};
